import React, { Component } from 'react'; 
import {Table, Row, Col, Button, Pagination, FormControl} from 'react-bootstrap';
import _ from 'lodash';

import Picky from 'react-picky';
import 'react-picky/dist/picky.css'; // Include CSS

function searchingFor(filterRows){
	return function(x){
      let key = _.keys(filterRows)
      let newObj =[]
      if(!_.isEmpty(key)){        
       _.map(key, (gg) =>{  
        if(!_.isNull(x[gg])){
          if(typeof x[gg] === "string"){
            newObj.push(x[gg].toLowerCase().includes(filterRows[gg].toLowerCase()))
          } else {
            newObj.push(x[gg].toString().includes(filterRows[gg].toString()))
          }
        }
      })
    }
    if(!_.isEmpty(newObj)){
      return !_.includes(newObj, false)
    } else {
       return true
    }
  }
}
export default class Mapping extends Component {
  constructor(props){
    super(props)
    this.state=this.getInitialState(props)
    this.bulkclientName = []
    this.handleFilter= this.handleFilter.bind(this)

  }
  getInitialState = (props) => {
    return {
      selectedauditors:[],
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      selectedSupervisor:[],
      activePage: 1,
      showAgents:false,      
      agentList:!_.isEmpty(props) ? props.agentList : [],
      filterRows:{},
      showFilter:false,
      options:[],
      enteredQuery:""

    }
  }
  UNSAFE_componentWillReceiveProps(nextProps){
    if(!_.isEqual(this.props.agentList, nextProps.agentList)){
      this.setState({agentList:nextProps.agentList})
    }
  }	

  regionNames = () => {
    const{selectedauditors} = this.state
    if(!_.isEmpty(selectedauditors)){    
      return selectedauditors.userInventoryMaps;
    }
     
  }
  
  centerNames = () => {
    const{selectedregionName} = this.state
    let centerNames =[]
      if(!_.isEmpty(selectedregionName)){   
        //_.map(selectedregionName, (obj) =>{
          centerNames = selectedregionName.userCenters
        //})
        return centerNames;
      }           
  }
  clientNames = () => {
    const{selectedcenterName} = this.state
    let clientNames =[]
    if(!_.isEmpty(selectedcenterName)){    
      // _.map(selectedcenterName, (obj) =>{        
       // this.bulkclientName=selectedcenterName.userClients
        clientNames = selectedcenterName.userClients
      //})
      return  _.uniqBy(clientNames, 'inventoryClientId')
    } 
  }
  processNames = () => {
    const{selectedclientName} = this.state
    let processNames = []
    if(!_.isEmpty(selectedclientName)){     
        //_.map(selectedclientName, (obj) =>{
            //let abc = _.filter(this.bulkclientName, {'inventoryClientId':obj.inventoryClientId})
          //_.map(abc, (z) => {
            processNames.push(...selectedclientName.userProcesses)
            processNames = _.uniqBy(processNames, 'inventoryProcessId');
          //}) 
        //})
        return processNames
    } 
  }
 
  handleSelectAuditors = (e) => {
    this.setState({selectedauditors: e});
    if(!_.isEqual(this.state.selectedauditors, e)){
      this.setState({selectedregionName:[], selectedprocessName:[], selectedcenterName:[], 
        selectedclientName:[], selectedSupervisor:[] , showAgents:false}) 
     }    
  }
  handleSelectRegion = (e) => {
    this.setState({selectedregionName: e});
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedprocessName:[], selectedcenterName:[], selectedclientName:[], selectedSupervisor:[]}) 
     }    
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      this.setState({selectedprocessName:[], selectedclientName:[], selectedSupervisor:[]}) 
     } 
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});
    if(!_.isEqual(this.state.selectedclientName, e)){
      this.setState({selectedprocessName:[], selectedSupervisor:[]}) 
     }
  }
  handleSelectProcess = (e) => {
    const {selectedregionName, selectedcenterName, selectedprocessName, selectedclientName} = this.state
    this.setState({selectedprocessName: e});
    if(!_.isEqual(selectedprocessName, e)){
      this.setState({selectedSupervisor:[]}) 
     }
    if(!_.isEmpty(e)){
    let obj = {
    "centers" : [selectedcenterName.inventoryCenterId],
    "clients" : [selectedclientName.inventoryClientId],
    "processes" : [e.inventoryProcessId],
    "regions" :  [selectedregionName.inventoryRegionId]
     }
      this.props.action.SupervisorSearch(obj)
    }
  }
  validateButton = () =>{
    const {selectedregionName, selectedcenterName, selectedSupervisor, selectedclientName, selectedprocessName} = this.state;
    if(!_.isEmpty(selectedregionName) && !_.isEmpty(selectedcenterName) && !_.isEmpty(selectedclientName) && !_.isEmpty(selectedprocessName) 
      && !_.isEmpty(selectedSupervisor)){
       return true;
    }
  }
  showAgents = () => {   
    const {selectedauditors, showFilter,  selectedregionName, selectedcenterName, selectedprocessName, selectedSupervisor, selectedclientName} = this.state
    let obj = {
      "auditorId" : selectedauditors.employeeId,  
      "centers" : [selectedcenterName.inventoryCenterId],
      "clients" : [selectedclientName.inventoryClientId],
      "processes" : [selectedprocessName.inventoryProcessId], 
      "regions" :  [selectedregionName.inventoryRegionId],
      'supervisorId': selectedSupervisor.key
    }
    this.setState({showAgents:true, agentList:this.props.agentList})
    if(showFilter === true){
      this.handleFilter()
    }
    this.props.action.AgentListSearch(obj)
  }
  handleSelectAgents = (checkedId, e) =>{
    const{agentList} = this.state;
    let obj = _.find(agentList, {agentId:checkedId})
    obj.mapped = e.target.checked
    this.setState({agentList})
  }
  handleSelectAgentsAll = (e) =>{
    const{agentList} = this.state;
    _.map(agentList, (obj) =>{
      obj.mapped = e.target.checked
    })
    this.setState({agentList})
  }
  handleSelectSupervisor = (e) =>{
    this.setState({selectedSupervisor: e});
  }
  getSupervisor= () =>{
    let supervisor  = []
    supervisor = this.props.supervisor
    if(!_.isEmpty(this.props.supervisor)){
      supervisor = _.uniqBy(supervisor, 'key')
    }
    return supervisor || []
  }
  mappingProcess = () =>{
    const{selectedauditors, agentList, selectedregionName,selectedcenterName,selectedclientName, selectedprocessName} = this.state;
    let agentListVal = _.filter(agentList) 
    let temp = {
      "auditorId": selectedauditors.employeeId,
      "auditorName": selectedauditors.firstName,
      "centerId" : selectedcenterName.inventoryCenterId,
      "clientId" : selectedclientName.inventoryClientId,
      "processId" : selectedprocessName.inventoryProcessId, 
      "regionId" :  selectedregionName.inventoryRegionId,
      "centerName" : selectedcenterName.inventoryCenterName,
      "clientName" : selectedclientName.inventoryClientName,
      "processName" : selectedprocessName.inventoryProcessName, 
      "regionName" :  selectedregionName.inventoryRegionName,
      "agents":_.map(agentListVal, (cx) =>{       
          return{'agentId':cx.agentId, 'agentName':cx.agentName, 'mapped':cx.mapped}
          })
    } 
    this.props.action.mapAgents(temp);
    let agentListValMap = _.filter(agentListVal, {'mapped':true})
    let temp2 = {
      "centerId" : [selectedcenterName.inventoryCenterId],
      "clientId" : [selectedclientName.inventoryClientId],
      "processId" : [selectedprocessName.inventoryProcessId], 
      "regionId" :  [selectedregionName.inventoryRegionId],
      "auditorId": selectedauditors.employeeId,
      "auditorName": selectedauditors.firstName,      
      "agents":_.map(agentListValMap, (cx) =>{    
          if(cx.mapped === true){
           return{'agentId':cx.agentId, 'agentName':cx.agentName, 'mapped':cx.mapped}
          }
          })
    }
    this.props.action.ReAssignAgents(temp2);
    this.setState(this.getInitialState())
  }
  handleSelectPagination = (eventKey) => {
    this.setState({
      activePage: eventKey,
    });
	}
	handleSelectPaginationPrev = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage-1,
    });
	}
	handleSelectPaginationNext = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage+1,
    });
  }
  handleChange = (e) => {
    const {filterRows} = this.state
    let filterCol = filterRows
    if(_.has(filterCol, e.target.id)){
      filterCol[e.target.id]  = e.target.value
    } else {
      filterCol = Object.assign(filterCol, {[e.target.id]:e.target.value})
    }
    this.setState({[e.target.id]:e.target.value, filterRows:filterCol})	
  }
  handleFilter = () =>{
    this.setState((prevState) =>{
      return {showFilter: !prevState.showFilter};
    })
    if(!_.isNull(this.state.filterRows)){
      let keys = _.keys(this.state.filterRows)
      _.map(keys, (obj) =>{
        this.setState({[obj]:""})
      })
      this.setState({filterRows:{}})
    }
  }
  reset  = () =>{
    this.setState(this.getInitialState())
  }
  handleQuerySearch = (e)=>{
    console.log(e.target.value,"enteredQuery")
    this.setState({enteredQuery:e.target.value})
  }
  handleSubmitSearch = () =>{
    let query = this.state.enteredQuery
    if(query.length < 1){
      return
    }
    let obj = {
      enteredVal:query
    }
    this.props.action.AuditorListAction(obj)
  }
	render(){		
    const{showAgents, agentList, activePage, filterRows, showFilter} = this.state;    
    const Per_Page=50;
    let totalPages;
    if(!_.isEmpty(agentList)){
     totalPages = Math.ceil(agentList.length/Per_Page)
    }
    const startOffset = (this.state.activePage-1) * Per_Page;
    let filterfield =[];
    filterfield.push(
      <tr className='filterRow'>
      <td><FormControl
      placeholder="Search"
      aria-label="Search"
      aria-describedby="basic-addon1"
      id={"agentId"}
      onChange={(e) => this.handleChange(e)}
      value={this.state.agentId}
      /></td>
      <td><FormControl
      placeholder="Search"
      aria-label="Search"
      aria-describedby="basic-addon1"
      id={"agentName"}
      onChange={(e) => this.handleChange(e)}
      value={this.state.agentName}
      /></td>
      <td></td>
      </tr>
    )
		let startCount = 0;
		let items = [];
		for (let number = 1; number <= totalPages; number++) {
			items.push(
				<Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
					{number}
				</Pagination.Item>				
			);
    } 
    console.log(this.props.auditorList,"filteredOptions---")
    console.log(this.state.options,"dummyFiltered")
   
    return(  
      <div>
        <Row>
          <Col>
          <label></label>
          </Col>
          <div style={{display:"flex",alignItems:"center",marginRight:"17px", marginBottom:"3px"}}>
          <input type='text' style={{
            height: "35px",
            border: "1px solid lightgray",
            borderTopLeftRadius: "4px",
            borderBottomLeftRadius: "4px",
            paddingLeft:"10px"
          }}
   value={this.state.enteredQuery} onChange={this.handleQuerySearch} placeholder='Search...'/>
          <button style={{
            height: "35px",
            border: "1px solid lightgray",
            borderTopRightRadius: "4px",
            borderBottomRightRadius: "4px",
          }} onClick={this.handleSubmitSearch}>Search QA</button>
          </div>
        </Row>
  
       <Row>
          <Col>
            <label>QA</label>
          </Col>
          <Col>
         <Picky keepOpen={false}
          value={this.state.selectedauditors}
          options={this.props.auditorList}
          onChange={this.handleSelectAuditors}
          open={false}
          valueKey="employeeId"
          labelKey="firstName"
          multiple={false}
          includeSelectAll={true}
          includeFilter={true}
          clearFilterOnClose={true}
          placeholder='QA'
          dropdownHeight={600}
          />
        </Col>
        </Row> 
       <Row>
        <Col>
          <label>Region Name</label>
        </Col>
       <Col>
       <Picky keepOpen={false}
         value={this.state.selectedregionName}
         options={this.regionNames()}
         onChange={this.handleSelectRegion}
         open={false}
         valueKey="inventoryRegionName"
         labelKey="inventoryRegionName"
         multiple={false}
         includeSelectAll={true}
         includeFilter={true}
         onFiltered={this.onFilterChange}
				 clearFilterOnClose={true}
         placeholder='Select Region'
         dropdownHeight={600}
       />
       </Col>
     </Row> 
       <Row>
       <Col>
         <label>Center Name</label>
       </Col>
       <Col>
       <Picky keepOpen={false}
         value={this.state.selectedcenterName}
         options={this.centerNames()}
         onChange={this.handleSelectCenter}
         open={false}
         valueKey="inventoryCenterName"
         labelKey="inventoryCenterName"
         multiple={false}
         includeSelectAll={true}
         includeFilter={true}
				 clearFilterOnClose={true}
         placeholder='Select Center'
         dropdownHeight={600}
       />
       </Col>             
     </Row>
       <Row>
        <Col>
        <label>Client Name</label>
        </Col>
        <Col>
        <Picky keepOpen={false}
          value={this.state.selectedclientName}
          options={this.clientNames()}
          onChange={this.handleSelectClient}
          open={false}
          valueKey="inventoryClientName"
          labelKey="inventoryClientName"
          multiple={false}
          includeSelectAll={true}
          includeFilter={true}
          clearFilterOnClose={true}
          placeholder='Select Client'
          dropdownHeight={600}
        />
     </Col>
     </Row> 
       <Row>
        <Col>
        <label>Process Name</label>
        </Col>
        <Col>
        <Picky keepOpen={false}
        value={this.state.selectedprocessName}
        options={this.processNames()}
        onChange={this.handleSelectProcess}
        open={false}
        valueKey="inventoryProcessName"
        labelKey="inventoryProcessName"
        multiple={false}
        includeSelectAll={true}
        includeFilter={true}
        clearFilterOnClose={true}
        placeholder='Select Process Name'
        dropdownHeight={600}
      />
      </Col>
      </Row> 
       <Row>
        <Col>
        <label>Supervisor </label>
        </Col>
        <Col> 
        <Picky keepOpen={false}
        value={this.state.selectedSupervisor}
        options={this.getSupervisor()}
        onChange={this.handleSelectSupervisor}
        open={false}
        valueKey="value"
        labelKey="value"
        multiple={false}
        includeSelectAll={false}
        includeFilter={true}
        clearFilterOnClose={true}
        placeholder='Select Supervisor'
        dropdownHeight={600}
      />
      </Col>
      </Row> 
        <br/>
       <Row><Col><center><Button onClick={this.showAgents} className='buttonwidth' size='md'
       disabled={!this.validateButton()}>List Agents</Button>&nbsp;
       {showAgents ? <Button className='buttonwidth' onClick={this.mappingProcess} >Map Agents</Button> : null}&nbsp;
       <Button className='buttonwidth' onClick={this.reset}>Reset</Button>
       </center></Col>
       
       </Row>
       {showAgents ?
      <div>
        <span className='alignRight'><b>Count - {_.filter(agentList, {'mapped':true}).length}</b></span>
    		 <Table responsive>
					<thead>
							<tr>
								<th><i class="fas fa-filter filterReport" onClick={this.handleFilter}/>AGENT ID</th>				
								<th>AGENT NAME</th>
								<th><input type='checkbox' checked={_.some(agentList, {'mapped':false}) ? false : true}
                  onClick={this.handleSelectAgentsAll}/></th>
							</tr>
              {showFilter ? filterfield : null}
					</thead>
          <tbody>  
            {(!_.isEmpty(agentList)) ?
            _.map(agentList.filter(searchingFor(filterRows)), (val, i) =>{
              if(i >= startOffset & startCount < Per_Page){
								startCount++;
              return(
                <tr>
                  <td>{val.agentId}</td>
                  <td>{val.agentName}</td>
                  <td><input type='Checkbox' checked={val.mapped === true} onClick={(e)=>this.handleSelectAgents(val.agentId, e)}/></td>
                </tr>                
              )
              }
            }) :
            <tr><td colSpan='3'>No Agents Found</td></tr>
            }
          </tbody>
          </Table>
           
           <br/>
          <Pagination>
          <Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
          <Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
            {items[activePage-1]}
            {items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
            {items[activePage+1]}
            {/* {items[0]}
            {(activePage !== 1)  ? items[activePage-1] : null}
            {(activePage !== totalPages)  ?   items[totalPages-1]   : null } */}
          <Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
          <Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
          </Pagination> 
           </div>
        : null }
      </div>       
    
    );

  }
}

